import React, { useState, useEffect } from 'react';
import { BQLink } from '../../../atoms/bqlink';
import { connect } from 'react-redux';
import { STRINGS } from '../../../../constants';
import get from 'lodash/get';
import { handleLogoClick, watchLiveInteraction } from '../../../../helpers/datalayer-utils';

import './get-in-touch.m.css';

const GetInTouch = ({ pageType, userData, footerList }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const width = window.innerWidth;
    setIsMobile(width <= 767);
  }, []);

  return (
    <div styleName="get-in-touch">
      <div styleName="logo-container">
        <div onClick={() => handleLogoClick(userData, pageType, isMobile)} styleName="logo">
          <BQLink href="/?src=footer">
            <img src="/icons/ndtv_profit_black.svg" styleName="ndtv-logo" alt="logo" />
          </BQLink>
        </div>
        <div className="mobile-only">
          <img src="/icons/ndtv_img.png" alt="NDTV" width="375px" height="227px" loading="lazy" />
        </div>

        <div
          styleName="action-button"
          onClick={() => watchLiveInteraction(userData, pageType, 'footer')}
        >
          <BQLink href={footerList?.links?.liveTvLink} styleName="watch-btn" title="Live TV">
            <img src="/icons/television-classic.svg" alt="television" height="14px" width="13px" />
            <span styleName="name">{STRINGS?.WATCH_LIVE}</span>
          </BQLink>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    footerList: get(state, ['qt', 'config', 'features', 'ndtv-footer'], {}),
  };
};

export default connect(mapStateToProps, null)(GetInTouch);
